<template>
    <div class="row mt-5">
        <div class="col-12">
            <div class="alert alert-secondary">
                <div class="alert-text">Additional documents</div>
            </div>
        </div>
        <div class="documents col offset-3">
            <div class="select-sides">
                <div class="left-side">
                    <h4>Docuemnts</h4>
                    <div class="item" v-for="(item) in preparedList" :key="item.id" v-show="!item.selected" @click="selectItem(item)">  
                        {{item.name}}
                    </div>
                </div>
                <div class="separator" /> 
                <div class="right-side">
                    <h4>Selected documents</h4>
                    <div class="item" v-for="(selectedItem) in selected" :key="selectedItem.id" @click="removeItem(selectedItem)">  
                        {{selectedItem.name}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import FormInput from '../../../../Shared/UI/Form/FormInput.vue';
import { mapGetters, mapMutations, mapActions } from 'vuex';


export default {
    name: 'shop-documents-data',
    components: { FormInput },
    props: {
        data: {
            type: Array,
            default(){
              return [];
            }
        },
        users: {
            type: Array,
            default(){
              return [];
            }
        }
    },
    data() {
        return {
            selected: this.documents,
            preparedList: []
        }
    },
    computed: {
        ...mapGetters({
            list: 'getDcouments'
        }),
        documents :{
            get(){
                return this.data;
            },
            set(newValue){
                this.$emit('update:data', newValue);
            }
        },
        shopusers :{
            get(){
                return this.users;
            },
            set(newValue){
                this.$emit('update:users', newValue);
            }
        }
    },
    methods: {
        selectItem(item){
            console.log("selectItem", item);
            item.selected = true;
            this.selected.push(item)
            this.documents = this.selected
        },
        removeItem(item){
            console.log("removeItem", item);
            item.selected = false;
            this.selected = this.selected.filter(i => i.id !== item.id)
            this.documents = this.selected

            this.preparedList = this.list.filter(d => {
                let findD = this.selected.find(s => s.id === d.id)
                if(findD)
                    return false;
                else return true;
            })
        }
    },
    validations: {

    },
    created(){
        console.log("created shopdocuments data", {documents: this.documents, users: this.users});
        this.selected = this.documents;
        this.preparedList = this.list.filter(d => {
            let findD = this.selected.find(s => s.id === d.id)
            if(findD)
                return false;
            else return true;
        })
    },
    updated(){
        console.log("Updated shopdocuments data", {documents: this.documents, users: this.users});
    }
};
</script>

<style lang="scss">


.select-sides {
    display:flex;
    flex-direction: row;

    border: 1px solid #d6d6d6;
    margin: 0px 15px;

    .left-side {
        width: 50%;
        padding: 15px;
    }

    .right-side {
       width: 50%;
       padding: 15px;
    }

    .separator {
        width: 1px;
        background: #000 ;
    }
    .item {
        cursor: pointer;
        margin-bottom: 10px;

        &:last-of-type {
            margin: 0;
        }
    }
}

    .btn-group-text{
        display: flex;
        display: -webkit-box;
        display: -ms-flexbox;
        border-bottom: 1px solid #ebedf2;
        padding: 5px 0;
        position: relative;
        -webkit-box-align: stretch;
        -ms-flex-align: stretch;
        align-items: stretch;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
        .group-text, .btn-group{
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-align: center;
            -ms-flex-align: center;
            align-items: center;
        }
        .group-text{
            -ms-flex-line-pack: flex-first;
            align-content: flex-first;
            margin-bottom: 0;
            color: #3d4465;
            font-size: 1.3em;
        }
        .btn-group{
            button{
                font-size: 1em;           
            }
            -ms-flex-line-pack: end;
            align-content: flex-end;
        }
    }
</style>
